<ws-modal-wrapper headerLabel="Create Invoice"
                  [loading]="loading"
                  acceptLabel="Create"
                  (save)="createInvoice()"
                  (cancel)="closeModal()">
    @if (!loading) {
        <div class="d-flex flex-column">
            <div class="d-flex mb-4 row align-items-center">
                <label class="col-md-3 text-end">Tax Year:</label>
                <span class="col-md-9">
                    <select class="form-select form-select-sm"
                            [(ngModel)]="year">
                        @for (item of years; track item) {
                            <option>{{ item }}</option>
                        }
                    </select>
                </span>
            </div>
            <div class="d-flex mb-4 row align-items-center">
                <label class="col-md-3 text-end">Service:</label>
                <span class="col-md-9">
                    <select class="form-select form-select-sm"
                            [(ngModel)]="contractServiceTypeId">
                        <option></option>
                        @for (contractServiceType of contractServiceTypes; track contractServiceType.id) {
                            <option [ngValue]="contractServiceType.id">{{ contractServiceType.name }}</option>
                        }
                    </select>
                </span>
                @if (validationMessages.contractServiceType) {
                    <div class="col-md-3 text-end"
                         style="color: var(--ace-danger);">
                        {{ validationMessages.contractServiceType }}
                    </div>
                }
            </div>
            @if (contractServiceTypeId === ContractServiceType.Appeal ||
            contractServiceTypeId === ContractServiceType.LitigationAdmin) {
                <div class="d-flex row align-items-center">
                    <label class="col-md-3 text-end">Property Type:</label>
                    <span class="col-md-9">
                        <select class="form-select form-select-sm"
                                [(ngModel)]="propertyTypeId">
                            <option [ngValue]="null"></option>
                            @for (propertyType of propertyTypes; track propertyType.id) {
                                <option [ngValue]="propertyType.id">{{ propertyType.name }}</option>
                            }
                        </select>
                    </span>
                    @if (validationMessages.propertyType) {
                        <div class="col-md-3 text-end"
                             style="color: var(--ace-danger);">
                            {{ validationMessages.propertyType }}
                        </div>
                    }
                </div>
            }
        </div>
    }
</ws-modal-wrapper>
